export const TYPE_REPAIR = ["แจ้งซ่อมรถ", "แจ้งซ่อมยาง", "แจ้งซ่อมแบตเตอรี่"];